
import Subtitle from '../../components/Subtitle/Subtitle';
import Title from '../../components/Title/Title';
import { Kyc, Question, Survey } from '../../types/KycTypes';
import KycQuestion from './KycQuestion';
import KycQuestionInfo from './KycQuestionInfo';

type KycGroupProps = {
    kycData: Kyc;
    group: Survey;
    questions: Question[];
};

const KycGroup = ({ kycData, group, questions }: KycGroupProps) => {
    return (
        <>
            <Title text={group.title} />
            {questions.map((question) => (
                <div key={question.name}>
                    <Subtitle text={question.label} />
                    <KycQuestionInfo info={question.info} />
                    <KycQuestion kycData={kycData} question={question} />
                </div>
            ))}
        </>
    );
};

export default KycGroup;
